<template>
  <ul class="pa-park-list-view">
    <template v-if="listType === 'foundedList'">
      <li v-for="item in parkList" :key="item.id">
        <PAParkBanner :parkId="item.id" :expireAt="item.expire_at" :link="true" />
      </li>
    </template>
    <template v-else>
      <li v-for="item in parkList" :key="item.id">
        <PAParkBanner :parkId="item.id" :link="true" />
      </li>
    </template>
  </ul>
</template>

<script>
import PAParkBanner from '@/components/Parts/PAParkBanner/PAParkBanner.vue'

export default {
  props : {
    listType : {
      default: 'parkList'
    },

    parkList : {
      default : () => {
        return [];
      }
    }
  },

  components : {
    PAParkBanner
  }
}
</script>

<style lang="scss">
.pa-park-list-view{
  width:98%;
  margin:.5rem auto;

  li{
    margin-bottom:1rem;
    cursor: pointer;
  }
}
</style>